/**
 * Page content loader for WPS Pages
 * Uses AlpineBlocks native loadContent method
 */

export function loadPageContent(editorElement, blocksData) {
    if (!editorElement) {
        console.error('Editor element not provided');
        return false;
    }
    
    // Wait for AlpineBlocks to be ready
    setTimeout(() => {
        // Use AlpineBlocks native loadContent method
        if (window.AlpineBlocks && window.AlpineBlocks.loadContent) {
            window.AlpineBlocks.loadContent(blocksData, 'alpineblocks-editor');
        } else {
            console.error('AlpineBlocks.loadContent not available');
        }
    }, 300);
    
    return true;
}

// Export for global use
window.loadPageContent = loadPageContent;